/*// src/layout/Footer.jsx
import React from "react";
export function Footer() {
    return (
        <div className="tb-footer">
            @ 2025 DIRECTV. DIRECTV and all other DIRECTV marks are trademarks of DIRECTV, LLC.
            All other marks are the property of their respective owners.
        </div>
    );
}
*/
// src/layout/Footer.jsx
import React from "react";

export function Footer() {
    const year = new Date().getFullYear();
    return (
        <div className="tb-footer">
            &copy; {year} DIRECTV. DIRECTV and all other DIRECTV marks are trademarks of DIRECTV, LLC.
            All other marks are the property of their respective owners.
        </div>
    );
}
